export default {
  done: "done",
  or: "or",
  to: "to",
  general: "general",
  not_found: "Not Found",
  mandatory: "mandatory",
  link: "link",
  text: "text",
  and: "and",
  All: "All",
  view: "View",
  see_all: "See all",
  optional: "optional",
  agreement: "agreement",
  title: "title",
  business_email: "Business email",
  description: "Description",
  confirmation: "Confirmation",
  passcode: "Passcode",
  dashboard: "Dashboard",
  services: "Services",
  ticketingSystem: "Ticketing System",
  assetManagement: "Asset Management",
  departments: "Autopilot",
  employees: "Users",
  users: "Users",
  directories: "Directories",
  activity_logs: "Activity logs",
  alerts: "Alerts",
  employee: "User",
  ERROR: "Error",
  TIMEOUT: "Timeout",
  SUCCESS: "Success",
  USER: "System",
  SYSTEM: "User",
  job_title: "Job title",
  softwares: "Softwares",
  no_employees: "No users",
  profile: "Profiles",
  devices: "Devices",
  device: "Device",
  category: "Category",
  current_user: "Current user",
  province_state: "Province/state",
  step: "step",
  device_ownership: "Ownership",
  new_logo: "new logo",
  no_result_found: "No result found",
  create_new: "Create new",
  administrator: "administrator",
  standard: "standard",
  fullname: "full name",
  username: "username",
  selected: "selected",
  firstName: "First name",
  REMOTE: "Remote",
  ON_SITE: "On Site",
  HYBRID: "Hybrid",
  FULLTIME: "Full Time",
  PARTTIME: "Part Time",
  supervised: "Supervised",
  FIXED_TERM_CONTRACT: "Fixed Term Contract",
  lastName: "Last name",
  secondName: "Second name",
  displayName: "Display name",
  mobileNumber: "Mobile phone number",
  companyName: "Company name",
  software: "Software",
  unassign: "Unassign",
  billing: "Billing",
  discard_progress: "Discard Progress",
  save_exit: "Save & Exit",
  integrations: "Integrations",
  password: "Password",
  password_type: "password type",
  password_hint: "Password hint (Optional)",
  type: "Type",
  status: "Status",
  actions: "Actions",
  action: "Action",
  view_script_log: "View script log",
  stop_script: "Stop script",
  run: "Run",
  sternx_footer: `${new Date().getFullYear()} TrioSoft Inc. All Rights Reserved`,
  quick_guide: "Quick Guide",
  privacy_policy: "Privacy Policy",
  terms_condition: "Terms & Conditions",
  new_trio: "New to Trio?",
  overview: "Overview",
  inventory: "Inventory",
  state: "Province/State",
  save_next: "Save & Next",
  alternate_email: "Alternate Email",
  phone_number: "Phone number",
  city: "City",
  postalCode: "Post Code",
  date_birth: "Date of Birth",
  postalCode_optional: "Post Code (Optional)",
  user: "User",
  info: "Info",
  close: "Close",
  settings: "Settings",
  cancel: "Cancel",
  ok: "Ok",
  yes: "Ok",
  continue: "Continue",
  save: "Save",
  ENABLED: "Enable",
  DISABLE: "Disable",
  DISABLED: "Disabled",
  DISABLED_MFA: "Disabled MFA?",
  ENABLED_MFA: "Enable MFA?",
  Yes_DISABLED_MFA: "Yes, Disable MFA",
  Yes_ENABLED_MFA: "Yes, Enable MFA",
  MFA_dialog_body:
    "MFA adds an extra layer of protection by combining your password & biometric data to verify their identity. are you sure?",
  add: "Add",
  MFA_is: "Your MFA is",
  MFA_activate: "Authenticator app has been successfully active.",
  active_MFA: "Active MFA",
  reset_MFA: "Reset MFA",
  students: "Students",
  teachers: "Teachers",
  save_changes: "Save changes",
  confirm: "Confirm",
  text_confirmation_description: "To confirm, enter <strong>{{text}}</strong>",
  Show: "Show",
  connect: "Connect",
  connect_with: "Connect with",
  not_connected: "Not connected",
  not_connect: "Not Connect",
  connected: "Connected",
  disconnect: "Disconnect",
  discard: "Discard",
  renew: "Renew",
  country: "Country",
  job_details: "Job details",
  details: "Details",
  manager: "Manager",
  reporter: "Reporter",
  email: "Email",
  work_email: "Work email",
  contract_type: "Contract type",
  start_date: "Start date",
  end_date: "End date",
  date: "Date",
  scheduled: "scheduled",
  work_type: "Work model",
  work_phone_number: "Work phone number",
  name: "Name",
  nothing_found: "Nothing found",
  email_address: "Email address",
  work_email_address: "Work email address",
  primary_phone_number: "Primary phone number",
  next: "Next",
  address: "Address",
  address_optional: "Address (Optional)",
  apple: "Apple",
  upload: "upload",
  update: "Update",
  updated: "updated",
  Updated: "Last Updated:",
  available: "Available",
  configure: "Configure",
  label: "label",
  windows_coming_soon: "Windows (coming soon)",
  android_coming_soon: "Android (coming soon)",
  back: "Back",
  submit: "Submit",
  learn_more: "Learn more",
  drag_file_here: "Drag your file here or",
  subscribe: "Subscribe",
  later: "I’ll do later",
  classes: "Classes",
  display: "Display",
  organization_information: "Organization information",
  MDM_setup: "MDM setup",
  security: "Security",
  admin_setting: "Admin settings",
  edit_name: "Edit name",
  edit: "Edit",
  general_setups: "General setups",
  upload_logo: "Company Logo",
  privacy_policies: "Privacy policies",
  terms_conditions: "Terms & conditions",
  file_type_valid: "File type is not valid",
  user_setting: "My account",
  file_size_valid: "File size is not valid",
  File_JPG_PNG: "File should be JPG or PNG",
  file_more_than_1MB: "File shouldn’t be more than 1MB",
  Sternx_GmbH: `${new Date().getFullYear()} Trio.so All Rights Reserved`,
  email_wrong: "Email format is wrong",
  email_invalid_company: "Invalid Company email",
  email_invalid_personal: "Invalid Personal email",
  link_wrong: "Link format is wrong",
  required_field: "Please Enter the {{fieldName}}",
  email_required: "Please Enter your Email",
  name_required: "This field is required",
  role_required: "Please Enter your role",
  passwords_must_match: "Passwords must match",
  organization_required: "Please Enter your organization",
  firstName_required: "Please Enter your first name",
  lastName_required: "Please Enter your last name",
  phone_required: "Please Enter your mobile number",
  located_required: "Please Enter your located",
  password_required: "Please Enter your password",
  enter_strong_pass: "Please enter a strong password",
  country_required: "Please Enter your country",
  address_required: "Please Enter your address",
  manager_required: "Please Enter your manager",
  city_required: "Please Enter your city",
  postalCode_required: "Please Enter your Post Code",
  state_required: "Please Enter your postal state",
  fullName_required: "Please Enter your full name",
  cardNumber_required: "Please Enter your card number",
  accountNumber_required: "Please Enter your account number",
  expirationMonth_required: "Please Enter your expiration month",
  expirationYear_required: "Please Enter your expiration year",
  cardCVV_required: "Please Enter your CVV",
  companyName_required: "Please Enter your company name",
  phoneNumber_valid: "phoneNumber must be a valid phone number.",
  admin_list: "Admin List & Settings",
  log_out: "Log out",
  OWNER: "Owner",
  IT_ADMIN: "IT Admin",
  ACTIVE: "Active",
  SUSPEND: "Suspended",
  UNVERIFIED: "Unverified",
  VERIFIED: "Verified",
  ONBOARD_INCOMPLETE_INFO: "Onboarding",
  INCOMPLETE_INFO: "Onboarding",
  ONBOARD_JOB_POSITION_NEEDED: "Onboarding",
  ONBOARD_DEVICE_POLICY_NEEDED: "Onboarding",
  ONBOARD_POLICY_NEEDED: "Onboarding",
  ONBOARD_APPS_NEEDED: "Onboarding",
  ONBOARD_ACCESSIBILITY_NEEDED: "Onboarding",
  ONBOARD_DEVICE_NEEDED: "Onboarding",
  ONBOARD_CONFIRM_NEEDED: "Onboarding",
  OFFBOARD_DEVICE_AND_DATA: "Offboarded",
  OFFBOARD_ACCESSIBILITY: "Offboarded",
  OFFBOARD_USER_ACCOUNT: "Offboarded",
  assign: "Assign",
  show_more: "Show more",
  DELETED: "Deleted",
  delete: "Delete",
  delete_department: "Delete Autopilot",
  password_strong:
    "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character",
  we_have_problem: "We have a problem!",
  Protocol: "Protocol",
  link_copied_success: "Link copied to clipboard!",
  copied: "Copied",
  link_copied_error: "Link copied error!",
  create: "create",
  birthDate: "Date of birth",
  birthDate_required: "Birth Date is required",
  phone_invalid: "Phone is invalid",
  homePhone: "Home Phone Number",
  IOS: "iPhone",
  ANDROID: "Android",
  MACOS: "Mac",
  drag_drop_clue1: "Drag & Drop or",
  drag_drop_clue2: "Upload",
  notifications: "Notifications",
  noNotification: "No notifications",
  noNotification_desc: "No notifications at this time",
  noDevice: "No Devices",
  BYOD: "BYOD",
  CO: "Company-owned",
  COD: "COD",
  COD_IN_OFFICE: "COD device in office",
  COD_OUT_OFFICE: "COD device out of office",
  read_privacy_policy: "Read Privacy & Policy",
  change_my_password: "Change my password",
  change_password: "Change password",
  reset_password: "Reset password",
  current_password: "Current password",
  new_password: "New password",
  define_new_strong_password:
    "Set a new, strong password that you can remember.",
  please_enter_current_password: "Please enter your current password",
  password_successfully_updated: "Your password successfully updated",
  update_credentials: "Update credentials",
  personal_information: "Personal information",
  multi_factor_authenticate: "Multi-factor authentication",
  MFA_not_activate_yet: "MFA is not activated for your account.",
  active_your_MFA: "Multi-factor authentication",
  connect_trio_authenticator: "First, Connect Trio with your Authenticator",
  count: "Count",
  input_TOTP: "Input TOTP",
  scan_QR_code: "Scan QR-Code",
  use_secret_key: "or use Secret Key",
  save_secret_key: "Save Secret Key",
  please_write_code_safe_place: "Please write this code down in safe place.",
  enter_first_generated_code:
    "After connection, Enter the first generated code.",
  mark_all_read: "Mark all as read",
  osLists: {
    MACOS: "Mac",
    IOS: "iPhone",
    WINDOWS: "Windows",
    ANDROID: "Android",
    TVOS: "tvOS",
    IPADOS: "iPad",
  },
  // devices_ownerships: {
  //   BYOD: "Brought your own device",
  //   COD: "Company Owned",
  //   COD_IN_OFFICE: "Company owned device in office",
  //   COD_OUT_OFFICE: "Company owned device out of office",
  // },
  WINDOWS: "Windows",
  generate: "Generate",
  applications: "Applications",
  no_country_found: "No Country founds",
  addedSuccessfully: "Added successfully",
  available_for_BYOD: "Available for BYOD",
  pageNotFound: "the page you requested cannot be found",
  backToHome: "Back to Home",
  CHOCOLATEY: "Chocolatey",
  GOOGLE_PLAY_STORE: "Google play store",
  APPSTORE: "App Store",
  CUSTOM: "Custom",
  ENTERPRISE: "Enterprise",
  TRIO_STORE: "Trio Store",
  discard_process: "Discard Process",
  department: "Autopilot",
  location: "Location",
  see_details: "See Details",
  monday: "Mon",
  tuesday: "Tue",
  wednesday: "Wed",
  thursday: "Thu",
  friday: "Fri",
  saturday: "Sat",
  sunday: "Sun",
  DONE: "Done",
  RECEIVED: "Received",
  RUNNING: "Running",
  PENDING: "Pending",
  default: "default",
  last_update: "Last update",
  activities: "Activities",
  filter: "Filter",
  filters: "Filters",
  time_remaining_resend_code: "{{time}} to resend code",
  time: "time",
  resend_code: "Resend code",
  offline: "Offline",
  online: "Online",
  free: "free",
  vulnerabilities: "Vulnerabilities",
  account: "Account",
  signOut: "Sign Out",
  progress_status: {
    Available: "Available",
    REVERTED: "Reverted",
    OPEN: "Open",
    DONE: "Done",
    PAUSE: "Pause",
    PENDING: "Pending",
    FAILED: "Failed",
    "IN-PROGRESS": "in progress",
    CANCEL: "Cancel",
  },
  version: "version",
  patch_management: "Patch management",
  active: "active",
  inactive: "inactive",
  compliance: "Compliance",
  appPolicies: "App Policies",
  show_less: "Show less",
  confim_password: "Confirm password",
  deviceOffileDesc: `This device is currently offline and cannot be accessed for the
service manager. Please check the devices network connection and
power status.`,
  deviceOffileDescActivityMonitor: `This device is currently offline and cannot be accessed for the
activity monitor Please check the devices network connection and
power status.`,
  deviceOffileDescTaskManager: `This device is currently offline and cannot be accessed for the
task manager Please check the devices network connection and
power status.`,
  deviceIsOffline: "Device is offline",
  goodMorning: "Good morning",
  goodEvening: "Good evening",
  goodAfternoon: "Good afternoon",
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December",
  help_center: "Help Center",
  contact_us: "Contact Us",
  created: "Created",
  view_edit: "View and edit",
  number: "number",
  created_time: "Created time",
  remove: "Remove",
  created_by: "Created by",
  date_locale: {
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    last: "Last",
  },
  last_activity: "Last activity",
  dateText: "Date",
  at: "at",
  termsAndConditions: "Terms and conditions",
  selectEmployeeDescription:
    "We’ll send enrollment links to the users' email addresses.",
  enrollmentHeader: "Select platform",
  ipadAndIphone: "iPad & iPhone",
  macOs: "Mac",
  windows: "Windows",
  organization: "Organization",
  sendEnrollmentEmail: "Send enrollment email",
  howToEnrollMacOsDevices: "How to enroll Mac devices",
  pleaseFollowTheStepsToEnrollDevice:
    "Please follow the steps to enroll device.",
  macOsEnrollStep1Title: "Download Mac agent",
  macOsEnrollStep1Description:
    "Download the Trio Mac agent to begin device enrollment.",
  macOsEnrollStep2Title: "Select Device Ownership",
  macOsEnrollStep2Description: `Choose if the device is ‘Company-Owned (COD)’ or ‘Employee-Owned (BYOD)’`,
  macOsEnrollStep3Title: "Install Trio agent",
  macOsEnrollStep3Description: `The relevant Trio agent will download and install based on the device type.`,
  macOsEnrollStep4Title: "Enter Pairing Code",
  macOsEnrollStep4Description: `Input the 6-digit pairing code to connect your device securely.`,
  macOsEnrollStep5Title: "Complete setup",
  macOsEnrollStep5Description: `Follow prompts to download and install the Mac MDM profile.`,
  macOsEnrollStep6Title: "Start managing",
  macOsEnrollStep6Description: `Manage your Mac devices seamlessly with Trio.`,
  whereDoYouWantToEnroll: "Where do you want to enroll?",
  enrollMethods: "Enrollment methods",
  viaCode: "Via Code",
  howToEnrollWindows: "How to enroll Windows devices",
  pleaseFollowTheStepsToEnroll:
    "Please follow the steps to enroll your device.",

  windowsEnrollStep1Title: "Download Windows agent",
  windowsEnrollStep1Description:
    "Download the agent to enroll Windows devices effortlessly.",
  windowsEnrollStep2Title: "Enter the pairing code",
  windowsEnrollStep2Description:
    "Enter a 6-digit pairing code to securely connect your Windows device.",
  windowsEnrollStep3Title: "Start managing",
  windowsEnrollStep3Description:
    "Start managing your Windows devices with ease.",

  downloadIosAndIpadProfile: "Download iPhone and iPad profile",

  iosEnrollStep1Title: "Download and install the profile",
  iosEnrollStep1Description: "A profile will be first installed on device",
  iosEnrollStep2Title: "Install Trio agent",
  iosEnrollStep2Description:
    "MDM server will install Trio Agent application from AppStore",
  iosEnrollStep3Title: "Start managing",
  iosEnrollStep3Description:
    "MDM Server will give an extra config to the app by setting device UDID along with Trio Agent installation, and the app will use UDID to register it-self.",
  forItAdminEnrollment: "For IT admin enrollment",
  chooseOwnweshipOfDevice: "Choose ownership of device",
  cod: "COD (Company owned)",
  downloadTheProfile: "Download the profile",
  downloadIosAndIpadOs: "Download iPhone & iPad profile",
  downloadProfileDirecty: "Download the profile directly (via link)",
  getProfile: "Get profile",
  downloadCompanyProfile: "Download Company profile",
  OS: "OS",
  store: "Store",
  price: "Price",
  apply: "Apply",
  autoInstall: "Install Type",
  activityDetails: "Event log details",
  assignedTo: "Assigned to",
  eventName: "Event name",
  selectAdmins: "Select from admins",
  timeline: "Timeline",
  startFrom: "Start from",
  endTo: "End to",
  selectDateRange: "Select date range",
  more: "more",
  all_current_location: "Device locations",
  last_log_activity: "Last log activities",
  no_geofence_added_yet: "No geofence added yet",

  inside_fence: "Inside the fence",
  outside_fence: "Outside the fence",
  missed: "Missed",
  without_fence: "without fence",
  inside_the: "inside the",
  outside_the: "outside the",
  outside_the_fence: "outside the fence",
  arrived: "Arrived",
  arrived_at: "arrived at",
  left: "Left",
  create_new_geofence: "Create new geofence",
  edit_geofence: "Edit geofence",
  geofence_name: "Geofence name",
  radius_in_meter: "Select radius range for this geofence",
  radius_m: "Radius (m)",
  radius: "Radius",
  select_type: "Select type",
  device_location: "Device location",
  assignment: "Assignment",
  assign_to_device: "Assign to devices ({{count}})",
  assign_to_device_group: "Assign to device group(s) ({{count}})",
  assign_this_profile: "Assign this profile to your preferred devices",
  assign_this_fence: "Assign this fence to to your preferred devices.",
  assign_this_fence_groups:
    "Assign this fence to to your preferred device groups.",
  view_and_mange_device: "View and manage device",
  precision: "precision",
  map_view: "Map View",
  list_view: "List View",
  map: "map",
  satellite: "Satellite",
  search_department: "Search autopilot",
  search_employee: "Search user name",
  search_geofence: "Search geofence",
  location_and_geofencing: "Location and geofencing",
  no_geofence_found: "No geofence found",
  locationSettingsTitle: `Set location tracking default value for autopilot`,
  locationSettingsDescription: `Some features not work on all devices and a silent attempt is done
            only on supported devices.`,
  departmentName: "Autopilot name",

  liveLocationAndGeofences: "Live location and geofences",
  logActivity: "Log activity",
  locationHistory: "Location history",
  locationTracking: "location tracking",
  lastUpdatedTime: "Last updated time",
  afewMomentsAgo: "a few moments ago",
  lastUpdateDescription:
    "We update device location every 15 minutes automatically.",
  removeDeviceFromFence: "Remove device from this fence",

  removeGeofenceDialogTitle: `Are you sure to remove this device from "{{fenceName}}"? `,
  removeGeofenceDialogFence:
    "Device's arrival/departure to/from the fence will no longer be tracked and you won't be notified about the device's location status regarding the fence.",
  disable: "Disable",
  enableLocationTracking: "Enable location tracking",
  deviceLogActivity: "Device location log activity",
  assignedFence: "Assigned Fence",
  refresh: "Refresh",
  locationIsNotAvailable: "Location isn't available",
  geofences: "Geofences",
  allDevicesHaveBeenUpdated: "All devices have been updated.",
  from: "From",
  end: "End",
  viewLocationHistory: "View location history",
  gotoDeviceDetails: "Go to device details",
  osType: "OS type",
  android: "Android",
  ios: "iPhone",
  macos: "Mac",
  withoutFence: "Without fence",
  notSpecified: "No location data",
  geofence: "Geofence",
  deviceAssignment: "Device assignment",
  createNewFence: "Create new fence",
  editFence: "Edit fence",
  createFenceDescription:
    "Choose your fence on the map and fill out the information about it.",
  notAssigned: "Not assigned",
  fence: "Fence",
  deviceName: "Device Name",
  noLog: "There is no log to show",
  networkMonitoring: "Network monitoring",
  networkMonitoringDesctiption: "Keep a real-time watch on all device ports.",
  scan: "Scan",
  activated: "Activated",
  noNetworkYet: "No network activity yet",
  deviceOfflineDescription: `This device is currently offline. Network monitoring can only be
              initiated when the device is back online.`,
  selectPeripherals: "Select a peripherals",
  selectAStorage: "Select a storage",
  whitelisted: "Whitelisted",
  id: "ID",
  storageName: "Storage name",
  serialNumber: "Serial number",
  addedDate: "Added date",
  noIssues: "No issues",
  controls: "controls",
  nothingAddedYet: "No devices yet",
  unassigned: "Unassigned",
  resultNotFound: "Result not found",
  noResults: "No result",
  eventDescription: "Event description",
  actor: "Actor",
  job: "Job",
  admin: "Admin",
  office: "Office",
  eventCategory: "Event category",
  no_log: "There is no log to show",
  unread: "Unread",
  all: "All",
  invoice_id: "Invoice ID",
  create_date: "Created date:",
  postal_code: "Postal Code",
  phone: "Phone",
  no_invoice: "No invoices exist",
  invoice_history:
    "You need to make your first purchase to see the invoice here.",
  billing_history: "Billing history",
  ready_to_choose: "Ready to choose?",
  choose_plan_trailor: "Choose a plan tailored to your needs.",
  compare_our_plan: "Compare our Plans & Features",
  growth: "Growth",
  advanced: "Advanced",
  enterprise: "enterprise",
  invoice_checkout: "Invoice Check out",
  how_many_employee: "How many user do you have?",
  buy_now: "Buy Now",
  sales_tax: "Sales tax may be applied based on your address information.",
  recommend: "recommended",
  per_employee: "Per user / Yearly",
  upgrade_plan: "Upgrade plan",
  day_remaining: "days remaining",
  fail_subscription: "Your subscription failed :(",
  please_try_again: "Please try again, or contact our support team.",
  all_done: "All Done!",
  your_interest: "Your interest in Trio fuels our passion.",
  billing_payment_success_title: "Payment successful",
  billing_payment_success_description:
    "Your payment has been completed successfully. Your subscription and billing details have been updated.",
  billing_success_redirect_prefix: "Redirecting you to Admin Panel in ",
  billing_success_redirect_suffix: " seconds...",
  billing_go_to_admin_panel: "Go to Admin Panel",
  billing_not_redirected: "Not redirected?",
  billing_click_here: "Click here",
  try_again: "Try again",
  youAlreadyhavePlan: "You already have a plan",
  directory: "Directory",
  organizations: "Organizations",
  DLP_description:
    "Integrating MDM with Forcepoint DLP enforces data protection policies,monitors risks, and ensures secure data handling across all managed devices, preventing unauthorized data transfers.",
  enforce_data_DLP:
    "Enforces data loss prevention policies on managed devices for secure data handling.",
  drag_drop: "Drag & Drop or browse to choose a file",
  uploading: "Uploading",
  upload_success: "File uploaded successfully",
  upload_fail: "Failed to upload the file",
  windows_upload_title: "Upload Forcepoint DLP Agent (Windows)",
  windows_upload_des:
    "Go to the <span style='color: #105FCF;'> Forcepoint DLP panel</span>, download the agent for integration with Trio MDM Device Management, and upload it here.",
  windows_upload_here: "Upload Windows Agent here",
  mac_upload_title: "Upload Forcepoint DLP Agent (Mac)",
  mac_upload_des:
    "Go to the <span style='color: #105FCF;'> Forcepoint DLP panel</span>, download the agent for integration with Trio MDM Device Management, and upload it here.",
  mac_upload_here: "Upload Mac Agent here",
  upload_cert_title: "Upload Forcepoint DLP Certificate",
  upload_cert_des:
    "Go to the Forcepoint DLP panel, download the certificate for integration with Trio MDM Device Management, and upload it here.",
  uploaded_success: "Uploaded successfully",
  select: "Select",
  follow_instruction: "Follow the instructions",
  select_where_apply: "Select where to apply",
  select_where_apply_des:
    "Select the devices where Forcepoint agents should be installed to enforce data protection and monitoring, ensuring compliance across your managed fleet.",
  all_devices: "All Devices",
  specific_departments: "Specific Autopilot",
  install_all_device: "This agent will be install on all devices",
  install_selected_device:
    "This agent will be install on all devices in selected autopilot. ",
  click_add_device: "Click here to add devices",
  complete: "Complete",
  select_department: "Select autopilot for integration",
  noNotificationYet: "You don’t have any notification",
  generalSettings: "General settings",
  cmdAndPowershellSettings: "CMD & PowerShell general settings",
  enableCMDAndPowershell: "Enable CMD & PowerShell Blocker",
  rdpGeneralSettings: "RDP Profile test general settings",
  enableRemoteDesktop: "Enable restriction on Remote Desktop",
  noTaskFound: "No task found",
  search: "Search",
  noPortFound: "No port found",
  lastLocation: "Last location",
  no_devices_added_yet: "No device added yet",
  addNewDevice: "Add new device",
  pass: "Pass",
  operationSystem: "Operation systems",
  seeDeviceDetails: "See device details",
  noLocationData: "No location data",
  copy: "Copy",
  viewReportsCisco: "View reports in the Cisco ISE panel.",
  tryTestConnection: "Try to test connection in Cisco ISE panel",
  useDataCertificate:
    "Use this data along with the certificate to complete the connection in the Cisco panel.",
  uploadCertificateCisco:
    "Upload the certificate in the Cisco panel. Then, open your terminal and run the command below to export it.",
  CiscoISEsecurityplatform:
    "Cisco ISE is a security platform for managing user and device authentication, access control, and compliance in a network.",
  statusCisco: "Status from Cisco",
  verifyConnectionCisco:
    "You can verify the connection in the Cisco ISE panel.",
  allowList: "Allow list",
  blockList: "Block list",
  sortBy: "Sort by",
  appsCount: "Apps count",
  os: "OS",
  groups: "Autopilot",
  addNewPolicy: "New Software Policy",
  operating_system: "Operating system",
  appPoliciesProperties: {
    ALLOWED: "Allowed list",
    BLOCKED: "Blocked list",
  },
  confirm_save: "Confirm & Save",
  addApplication: "Add Application",
  addFromInventory: "Add from Inventory",
  trioRepo: "Trio Repo",
  selectedApplications: "Select applications",
  sourceTypes: {
    DEVICE: "Device",
    STORE: "Store",
    ENTERPRISE: "Enterprise",
  },
  Department: "Department",
  employee_ID: "Employee ID",
  discardChanges: "Discard Changes?",
  allSetupsLost: "All the setups will be lost.",
  newPolicyCreated: "New policy created",
  assignPolicyToDescription:
    "Do you want to assign this Software Policy to your autopilot or devices?",
  assignToGroup: "Assign to autopilot",
  no_app_added: "No application added yet",
  no_app_found: "No application found",
  addApplicationToThePolicy:
    "Add application to this policy to ensure security while using the apps. ",
  application: "Application",
  deleteApplicationTitle: "Do you want remove this application",
  deleteApplicationDescription:
    "Are you sure you want to remove this application",
  deleteDepartmentsTitle: "Do you want delete this autopilot",
  deleteDepartmentsDescription:
    "Are you sure you want to delete this autopilot",
  yesDelete: "Yes, Delete",
  passcodeDescription: "The passcode is needed to unlock the device.",
  contactInformation: "Contact information",
  contactInformationDescription:
    "A description is needed to be displayed on the locked device. ",
  locationDescription: "This description show on lock screen.",
  inputRadius: "Input radius",
  install: "Install",
  uninstall: "Uninstall",
  deviceApplications: "Device applications",
  appName: "Software Name",
  publisher: "Publisher",
  installationStatus: "Installation status",
  applicationStateEnum: {
    APPLICATION_STATE_UNSPECIFIED: "Unspecified",
    REMOVED: "Removed",
    INSTALLED: "Installed",
    INSTALLING: "Installing",
    IN_PROGRESS: "in Progress",
    INSTALLATION_FAILURE_REASON_UNKNOWN: "Fail",
    "Unknown - status": "Unknown Status",
  },
  activatedLength: "{{length}} Activated",
  SearchPublisher: "Search publisher",
  searchCategory: "Search category",
  installed: "Installed",
  uninstalled: "Uninstalled",
  inFullScreenMode:
    "In full screen mode, users can't use their device until they complete the Liftoff run.",
  added: "Added",
  not_added: "Not added",
  geofenceHistoryHeaderDescription: `As devices check in or out, the admin can see the device status and the action taken for each device within each fence.`,
  geofenceHistory: "Geofence history",
  deviceAssignedFencesDescription:
    "Set a fence, arrange the radius, assign devices to the fence, and see the activity log fir each fence.",
  actionSettings: "Action settings",
  actionSettingsHeaderDescription: `Lock: The device will automatically lock according to the fence setting to protect the data and ensure device security.<br /><br /> Wipe: According to the fence setting, the device will be automatically wiped and all the data will be erased.`,
  noFences: "No fences",
  noActivity: "No activity",
  locationAndGeofenceHeaderDescription: `Add fences, assign devices, and get detailed reports of device check in / out status. `,
  configureForcepointDLP: "Configure Forcepoint DLP",
  assignedtoGroups: `Assigned to <strong>{{length}} autopilot</strong>.`,
  confirmDeletionDLP: "Confirm Deletion of Forcepoint DLP Configuration",
  deleteForcepointDLP:
    "Are you sure you want to delete the Forcepoint DLP configuration? This action cannot be undone.",
  selectName: "Select Name",
  nameConfiguration: "Name this configuration",
  your_file_successfully: "Uploaded successfully",
  success: "Success",
  dateTime: "Date/Time",
  addNewPortRestriction: "Add new port restriction",
  enableActionBlock: "Enable action block",
  noPortRestricitonYet: "No port restriction added yet",
  event: "Event",
  deviceIsMakingBuzzSound: "Device is making buzz sound.",
  noAppPolicyAddedYet: "No Software Policy added yet",
  noAppPolicyFound: "No Software Policy found",
  noGroupAddedYet: "No Autopilot added yet",
  noGroupFound: "No Autopilot found",
  editAppPolicy: "Edit Software Policy",
  seeDetails: "See Details",
  editBasicInfo: "Edit Basic Info",
  assignGroups: "Assign Autopilot",
  deleteAppPolicy: "Remove {{name}}",
  removeApp: "Remove application?",
  removeGroup: "Remove autopilot?",
  deleteAppPolicyDescription:
    "Are you sure you want to remove this Software policy?",
  portRestriction: "Port restriction",
  portRestrictionDrawerDescription:
    "Specify the port and protocol to restrict network access.",
  portNumber: "Port number",
  portShoudntBeMoreThan65535: "Port shouldn't be more than 65534",
  chooseProtocol: "Choose a protocol",
  portNumberList: "Port number list",
  actionBlock: "Action block",
  portRestrictionSettings: "Port restriction settings",
  portRestrictionSettingsDescription: `Configure which applications can access specific network ports
                to enhance security and prevent unauthorized access.`,
  MACOS15: "Sequoia",
  MACOS14: "Sonoma",
  MACOS13: "Ventura",
  WIN10: "Windows 10",
  WIN11: "Windows 11",
  WIN11_ENTERPRISE: "Windows 11 enterprise",
  WIN10_ENTERPRISE: "Windows 10 enterprise",
  osFailedControls: "{{os}} Failed controls:",
  allSet: "All set",
  remediateAllOsControl: "Remediate all",
  remediating: "Remediating...",
  remediateAllDevices: "Remediate all devices",
  recheckAllOsControl: "Re-check all {{os}} devices",
  recheking: "Recheking...",
  noDeviceFound: "No device found",
  onboardingProcessTracker: "Onboarding Process Tracker",
  onboardingProcessTrackerContent:
    "Review and track the onboarding process for the Users.",
  currentStep: "Current step",
  progress: "Progress",
  totalUser: "Total Users",
  totalUserContent: "Review all the Users added to the Autopilot.",
  OffboardingProcessTracker: "Offboarding Process Tracker",
  OffboardingProcessTrackerContent:
    "Review the process of off-boarding the existing Users on Trio.",
  TopGroupsUserCount: "AutoPilots with Most Users",
  TopGroupsUserCountContent:
    "See which AutoPilots have the highest number of users.",
  UserAddedByMethod: "User Adding Methods",
  UserAddedByMethodContent:
    "View how users were added with counts for each method.",
  UserCountByGroup: "Users by Autopilot",
  UserCountByGroupContent: "Check user numbers in AutoPilots.",
  UserStatuses: "User Status",
  UserStatusesContent: "See user counts broken down by their current status.",
  software_distribution: "Software Distribution",
  software_distribution_content:
    "View software distribution across different operating systems.",
  software_installed: "installed",
  profile_platform: "Policies by platform",
  profile_platform_content:
    "Review policies by operating system for enrolled devices.",
  iPadOS: "iPad",
  Windows: "Windows",
  macOS: "Mac",
  Android: "Android",
  iOS: "iPhone",
  profiles_in_chart: "Profiles",
  deviceIntoButtonText: "Enroll a device",
  groupIntoButtonText: "Create your first autopilot",
  userIntoButtonText: "Add your first user",
  softwareIntoButtonText: "Add software to your library",
  profileIntoButtonText: "Set up a profile",
  enrollDevice: "Enroll Device",
  enrollDeviceDescription:
    "Hands-on device enrollment across platforms like Mac, iPhone, Windows, and Android. Easily link devices to users and autopilot for seamless management.",
  createGroup: "Create Autopilot",
  createGroupDescription:
    "Organize users and devices by creating a Autopilot. Assign profiles, software, and devices to keep everything streamlined and easy to manage.",
  addUser: "Add User",
  addUserDescription:
    "Start adding users to your panel. Learn how to onboard, assign to autopilot, and set up access for a seamless user experience.",
  addSoftware: "Add Software",
  addSoftwareDescription:
    "Manage essential software by adding it to your library. Assign it to specific autopilot or devices for easy distribution and access.",
  createProfile: "Create Profile",
  createProfileDescription:
    "Create a security or configuration Profile with policies that help protect devices. Assign it to devices or autopilot to ensure consistent security across your organization.",
  getMostTrio: "Get the most out of Trio",
  percentageTotal: "{{percentage}}% of total",
  tourComplete: "Tour Complete – Start Managing!",
  completedTour:
    "You've completed the tour! Access resources or dive into managing users, devices, and configurations independently.",
  finishExplore: "Finish and Explore",
  createWorkspace: "Create workspace",
  createMyWorkspace: "Let’s create my workspace",
  stepOf: "Step {{page}} of 5",
  getStartedTrio: "Get started on Trio",
  getStartedTrioDescription:
    "Trio empowers you to efficiently manage devices, enhance security, and streamline IT operations for your organization.",
  fileTypeInvalid: "File type is not valid",
  fileShouldBeJpg: "File should be JPG or PNG",
  fileShouldNotBeBiggerThan2mb: "File shouldn’t be more than 2MB",
  welcomeToCompanyInformation: "Welcome to Trio!",
  companyInfoDescription: "Follow the steps to complete account setup.",
  uploadLogo: "Company Logo",
  pleaseUploadCompanyLogo: "Please upload a square .png or .jpg image.",
  skipAndNext: "Skip & next",
  contactInfoDescription: `Contact details that we keep on-file for support purposes.`,
  companyContactEmail: "Contact Email",
  emailIsNotUsable: "Email is not usable",
  primaryPhoneNumber: "Contact Number",
  phoneIsNotUsable: "Phone is not usable",
  mainOfficeAddress: "Main office address",
  mainOfficeDescription: `Provide the address of your main office location.`,
  officeName: "Office Name",
  termAndCondition: "Terms & Condition",
  enterCompanyInformation: "Enter company information",
  enterKeyDetails: "Enter key details to personalize your Trio workspace.",
  uploadPNGJPEG: "Upload PNG or JPEG files under 2MB",
  emailEssentialCommunication:
    "This email is used for essential communication and options.",
  enterMainOffice:
    "Enter the main office details including office name, country, state, city, and postal code.",
  companyTermsConditions: "Company terms and conditions",
  invalidUrl: "The Url is invalid",
  provideTermsVia: "Provide terms via link or enter manually.",
  linkExisting: "Link to existing",
  writeManually: "Write Manually",
  yourLinkGoesHere: "Your link goes here",
  yourURL: "Your URL must begin with `https://`",
  remediateDevice: "Remediate device",
  recheck: "Re-check",
  auditRemediation: "Audit & remediation",
  totalGroups: "Total AutoPilots",
  totalGroupContent:
    "View the total number of AutoPilots in your organization.",
  totalDevices: "Total devices",
  totalDevicesContent: "View the total number of enrolled devices.",
  totalSecurityProfile: "Security Policies",
  totalSecurityProfileContent:
    "Review the total security policies assigned to the devices.",
  andMore: "and {{length}} more",
  totalSoftware: "Total Software",
  totalSoftwareContent: "View the total number of software packages available.",
  totalConfigurationProfile: "Configuration Policies",
  totalConfigurationProfileContent:
    "Review the total configuration policies assigned to the devices.",
  acronisConnect: "Connect to your Acronis",
  trySetConnectionAcronis: "Try to test connection in Acronis panel",
  linkYourAcronis:
    "Link your Acronis account now to securely and automatically back up all of your Trio devices and protect your data.",
  urlAcronis: "Acronis URL",
  accountAcronis: "Acronis Account",
  activate: "Activate",
  acronisGlobalTech:
    "Acronis is a global technology company that provides businesses and organizations with protection against cyberattacks, hardware failures, natural disasters, and human errors.",
  backup: "Backup",
  app_success_assign: "App Successfully Assigned",
  deviceByComplianceState: "Device by Compliance State",
  deviceByComplianceStateContent:
    "View compliance status breakdown for all devices.",
  arenotCompliant: "are not compliant",
  compliant: "compliant",
  nonCompliant: "non-compliant",
  patchVulnerabilities: "Patch & Vulnerability",
  installAll: "Install All",
  viewPatchDetail: "View Patch Detail",
  detected: "Detected",
  cveId: "CVE ID",
  severityScore: "Severity Score",
  affectedVersion: "Affected Version",
  critical: "Critical",
  high: "High",
  noPatch: "There is no OS patch",
  topVulnerabilityDevices: "Most Vulnerable Devices",
  NoVulnerabilities: "No vulnerabilities found on devices",
  topOSPatches: "Top OS Patches",
  patchingProgress: "Patching progress",
  topSoftwarePatches: "Top Software Patches",
  enrollmentType: "Enrollment Type",
  enrollmentTypeContent:
    "See how devices are enrolled across organizations, AutoPilots, and users.",
  toOrganization: "To Organization",
  toGroup: "To Autopilot",
  toUser: "To User",
  top5SecurityIssues: "Top 5 Security Issues",
  top5SecurityIssuesContent:
    "View the most common security issues across devices.",
  issue: "Issue",
  fix_now: "Fix now",
  availableBattery: "Available Battery",
  availableBatteryContent:
    "View battery percentage across all enrolled devices.",
  device_name: "Device name",
  percentage: "Percentage",
  availableStorage: "Available Storage",
  availableStorageContent:
    "View available storage space across all enrolled devices.",
  availableStorage_table_header: "Available Storage",
  group_changes_logs: "Autopilot Changes/Logs",
  group_changes_logs_content:
    "View recent changes made to AutoPilots and who made them.",
  last_3_days: "Last 3 days",
  last_week: "Last week",
  last_month: "Last month",
  today: "Today",
  userName: "User",
  table_time: "Date",
  event_description_item: "Item",
  ownership_distribution: "Ownership Distribution",
  ownership_distribution_content: "See corporate vs personal device breakdown.",
  byod_chart: "BYOD",
  cod_chart: "COD",
  input_group_name: "Autopilot name",
  input_group_description: "Description (Optional)",
  input_manager_id: "Select a manager(Optional)",
  company_email: "Company email",
  personal_email: "Personal email",
  search_alert: "Search another event name, device or category",
  event_success_update: "Event update successfully",
  not_find_result: "Couldn’t find your result",
  ConfigureAPNs: "Configure APNs",
  AddDevice: "Add Device",
  configureAutomateEnrollment: "Configure Automate Enrollment",
  exploreGroups: "Explore Autopilot",
  exploreSecurity: "Explore Security",
  setyourTrio: "Set up your Trio",

  delete_warning: "This action cannot be undone.",
  delete_cancel: "Cancel",
  delete_unassign: "Unassign",
  delete_delete: "Delete",
  //unassign employee
  user_delete_title: "Delete User?",
  user_delete_description: "Do you want to delete the user permanently?",
  user_delete_cancel: "Cancel",
  user_delete_delete: "Delete",
  //unassign device
  unassign_delete_title: "Unassign devices?",
  unassign_delete_description:
    "Do you want to unassign devices from the autopilot permanently?",
  unassign_delete_cancel: "Cancel",
  unassign_delete_delete: "Unassign",
  unassign_delete_subDescription: "Main Assets:",
  unassign_dependency_delete_cancel: "Cancel",
  unassign_dependency_delete_title: "Unassign devices?",
  unassign_dependency_delete_description:
    "Do you want to unassign devices from the autopilot permanently? ",
  unassign_dependency_unable_main_assets: "Main Assets:",
  unassign_dependency_unable_delete_warning: "This action cannot be undone.",
  unassign_dependency_success_delete_title: "Device unassigned!",
  unassign_dependency_success_delete_description:
    "The device has been unassigned successfully.",

  //remove software
  software_delete_title: "Delete from library?",
  software_delete_description:
    "Are you sure you want to delete this app from your library?",
  software_delete_cancel: "Cancel",
  software_delete_delete: "Delete",
  software_delete_subDescription: "Main Assets:",
  software_dependency_delete_cancel: "Cancel",
  software_dependency_delete_title: "Delete Application?",
  software_dependency_delete_description:
    "Are you sure you want to delete this app from your library? All associated data will be permanently deleted.",
  software_dependency_unable_main_assets: "Main Assets:",
  software_dependency_unable_delete_warning: "This action cannot be undone.",
  software_dependency_success_delete_title: "Device unassigned!",
  software_dependency_success_delete_description:
    "The device has been unassigned successfully.",
  software_dependency_delete_uninstall: "Delete & Uninstall",

  // delete geofence
  geofence_delete_title: "Delete Geofence?",
  geofence_delete_description:
    "Are you sure you want to delete this geofence from your list? All setting will be permentatly deleted.",
  unable_geofence_delete_warning:
    "By deleteing this geofence, all devices assigned devices will revert to their default state.",
  geofence_delete_cancel: "Cancel",
  geofence_delete_delete: "Delete",
  success_geofence_delete_title: "Geofence deleted!",
  success_geofence_description: "The Geofence has been deleted successfully.",
  success_app_policy_delete_title: "Software policy deleted!",
  success_app_policy_delete_description:
    "The Software Policy has been deleted successfully.",

  //application removed in Software policy
  success_application_removed_title: "Application removed!",
  success_application_removed_description:
    "The application has been removed successfully.",

  //Software policy delete
  user_success_delete_title: "User deleted!",
  user_success_delete_description: "The user has been deleted successfully.",
  delete_app_policy_title: "Delete Software Policy?",
  delete_app_policy_sub_title: "This Software Policy assigned to",
  delete_app_warning_one:
    "By deleting this Software policy, it will be turned off for this autopilot.",
  delete_app_warning_two: "This action cannot be undone.",
  delete_app_policy_description:
    "Are you sure you want to delete this Software Policy from the list",
  delete_app_policy_cancel: "Cancel",
  delete_app_policy_delete: "Delete",
  software_success_delete_title: "Application deleted!",
  software_success_delete_description:
    "The application has been deleted from the App Library.",

  group_device_success_delete_title: "Device unassigned!",
  group_device_success_delete_description:
    "The device has been unassigned successfully.",
  start_offboarding: "Start offboarding",
  profile_success_delete_title: "Profile removed!",
  profile_success_delete_description:
    "The profile has been removed successfully.",

  group_policy_success_delete_title: "Autopilot removed!",
  group_policy_success_delete_description:
    "The autopilot has been removed successfully.",
  seeMore: "See more",
  complianceAutomation: "Compliance Automation",
  vulnerabilityCenter: "Vulnerability Center",
  hide: "Hide",
  show: "Show",
  eventLogs: "Event logs",
  deviceLogs: "Device logs",
  QUEUED: "Pending",
  FAILED: "Failed",
  noPolicyYet: "You don’t have any Policy yet",
  user_groups: "No user autopilot yet",
  autopilot: "Autopilot",
  DEPLOYED: "Deployed",
  EXPIRED: "Expired",
  cloudDirectories: "Cloud Directories",
  cloudDirectory: "Cloud Directory",
  directoryName: "Directory Name",
  useANameToIdentifyThisIntegrationInstance:
    "Use a name to identify this integration instance.",
  enterAUniqueName: "Enter a unique name",
  setADirectoryName: "Set a Directory Name",
  note: "Note",
  youCanImportUsersWithTwoMethodsManuallyOrAutomatically: `You can import users with two methods, manually or automatically.`,
  googleWorkspace: "Google workspace",
  selectSpecificNewUsersToImport: "Select specific new users to import",
  selectSpecificNewUsersToImportDescription:
    "View and select specific new users to import from Google into Trio. A suspended user in google will import as suspended in Trio.",
  allNewAndUpdatedUsers: "All New and updated users",
  allNewAndUpdatedUsersDescription:
    "Import all new users and user updates from google into Trio.",
  onlyUpdatedUsers: "Only updated users",
  onlyUpdatedUsersDescription:
    "Import all updated users from Google into Trio.",
  onlyNewlyAddedUsers: "Only newly added users",
  onlyNewlyAddedUsersDescription: "Import all new users from Google into trio.",
  googleManualImportDescription:
    "Select the new users you want to import and/or the already imported users you want to update from Google into Trio.",
  learnMore: "Learn more",
  importUsers: "Import users",
  provisioningNotes: "Provisioning Notes",
  googleProvisioningNote1:
    "Active Google users will be imported as Staged users by default.",
  googleProvisioningNote2:
    "View Settings Suspended users in Google can be imported as Suspended in the MDM system.",
  manualImport: "Manual Import",
  googleManualImportDescriptionMDM:
    "Control which users from the directory are brought into your MDM system.",
  startManualImport: "Start manual import",
  automaticSync: "Automatic Sync",
  googleAutomaticSyncDescription:
    "We will automatically sync users from your Google Workspace every 24 hours.",
  attributeMappingAndSettings: "Attribute Mapping and Settings",
  googleAttributeMappingAndSettings: `Decide which user attributes will be exported to the connected
                  directory. Exported values will replace the existing values in
                  the destination system`,
  googleAttributeMappingAndSettingsNote: `For sensitive fields such as passwords and user status, your selections may affect authentication settings.`,
  backToList: "Back to List",
  saveChanges: "Save changes",
  noDirectoryConnected: "No Directory Connected",
  noDirectoryConnectedDescription: `Sync your organization's users and groups from a cloud directory.
 Automatically provision accounts and keep them updated in real time.`,
  googleWorkspaceCardDescription: `"Sync users, organizational units, and groups from Google Workspace into your MDM platform. Keep identities updated automatically or on-demand."`,
  connectGoogleWorkspace: "Connect Google Workspace",
  connectMicrosoftEntraId: "Connect Microsoft Entra ID",
  microsoftWorkspaceCardDescription:
    "Import and manage users and groups from Microsoft Entra ID (Azure AD). Ensure your MDM directory stays aligned with your identity source.",
  microsoftEntraId: "Microsoft Entra ID",
  whatThisIntegrationEnables: "What this integration enables",
  areYouSure: "Are you sure",
  deletedSuccessfully: "Deleted Successfully",
  deleteCloudDirectoryConfirmation: `Are you sure you want to remove this cloud directory?`,
  cloudDirectoryDescriptionBreadCrumb: `"Connect to Google Workspace or Microsoft Entra ID to sync users and groups. Keep identities updated for real-time provisioning."`,
  cloudDirectoryCallbackBreadCrumb:
    "Configure identity provider settings including directory name, user import options, domain matching, and sync behavior. Monitor connection status and manage user/group synchronization.",
  googleCloudDirectoryTitle:
    "Welcome to Google Workspace Directory Integration",
  googleCloudDirectoryDescription:
    "Connect your Google Workspace directory to automatically sync users and organizational units into your MDM platform.",
  userSyncing: "User Syncing",
  googleCloudDirectoryUserSyncingDescription:
    "Import and update user accounts directly from Google Workspace.",
  automaticOrManualSync: "Automatic or Manual Sync",
  googleCloudDirectoryAutomaticOrManualSyncDesc:
    "Choose between scheduled daily syncs or manual on-demand syncing.",
  secureOauthConnection: "Secure OAuth Connection",
  googleCloudDirectorySecureOauthConnectionDesc:
    "Authenticate using Google’s secure OAuth 2.0 protocol.",
  googleCloudDirectoryRequirement1:
    "Read-only access to users, groups, and organizational units",
  googleCloudDirectoryRequirement2: "No access to emails or private files",
  googleCloudDirectoryRequirement3: "OAuth 2.0 consent for your admin account",
  configureGoogleWorkspace: "Configure Google Workspace",
  configureGoogleWorkspaceDescription:
    "Provide a unique name for the user integration and sign in to your Google Workspace account. You will need to authenticate as an administrator.",
  configureGoogleWorkspaceInfobox:
    "This name will appear in the Integrations list and on the Directory Sync logs page. If you manage multiple domains or test environments, use a name that helps distinguish this directory integration",
  configureGoogleWorkspaceTextboxHint:
    "Label for the synced directory (e.g., “Google HR Users”)",
  signInWithGoogle: "Sign in with Google",
  configureGoogleWorkspaceMoreDetail: `You’ll be redirected to sign in with a Google admin account to
              authorize this integration. This is required only once to
              establish a secure sync connection.`,

  microsoftAttributeMappingAndSettingsNote: `For sensitive fields such as passwords and user status, your selections may affect authentication settings.`,
  trioCloudToExport: "Trio cloud to export",
  trioAttribute: "Trio attribute",
  microsoftImportUsers: `You may run another import of new M365/Entra ID users to your current Trio user base at any point.`,
  microsoftAttributeMappingAndSettings:
    "Choose which user attributes Trio exports to the connected directory. Exported values overwrite any existing values.",
  manuallyImport: "Manually Import",
  identityProviders: "Identity Providers",
  setUpIdentityProviders: "Set up identity providers",
  noIdentityProviderDescription:
    "Connect Google or Microsoft as your organization’s identity provider. Once connected, users sign in to Trio with SSO and no extra passwords to manage.",
  googleIdentityProviderDescription:
    "Use your organization’s Google credentials to sign in. OIDC secures authentication and centralizes user lifecycle management in Google Admin.",
  setupSSO: "Set up SSO",
  microsoftEntraIdIdentityProvider:
    "Let employees sign in with their Microsoft work account. OIDC-based SSO keeps passwords out of Trio and enforces policies from Entra ID.",
  googleIdentityProviderTitle:
    "Welcome to Google Workspace Identity Provider Integration",
  multiDomainSupport: "Multi-domain Support",
  googleIdentityMultiDomainSupportDescription:
    "Configure multiple domains and SSO connections for different teams.",

  secureAuthentication: "Secure Authentication",
  googleIdentitySecureAuthenticationDesc:
    "Uses OIDC and OAuth 2.0 for strong encryption and safe login experiences.",
  justInTimeProvisioning: "Just-in-Time Provisioning",
  googleIdentityProviderJustInTimeProvisioningDesc:
    "Optionally create user accounts on first login.",
  googleIdentityProviderRequirement1: "Authenticate users using OIDC",
  googleIdentityProviderRequirement2: "Verify domain ownership",
  googleIdentityProviderRequirement3:
    "Retrieve basic user profile (email, name, ID)",
  googleIdentityNameFieldDesc:
    "Provide a name for the SSO connection. Cannot exceed 32 characters.",
  googleWorkspaceDomain: "Google Workspace Domain",
  googleIdentityDomainDesc: "The domain of your Google Workspace account.",
  clientId: "Client ID",
  googleIdentityClientIdDesc:
    "The unique identifier for your registered Google workspace application.",
  clientSecret: "Client Secret",
  googleIdentityClientSecretDesc:
    "The Client secret for the Google Workspace application.",
  googleIdentityConfigInfoDesc:
    "We’ll authenticate users using OIDC. Only users from the allowed Google Workspace domains will be able to log in.",
  googleClientSecretIsRequired: "Client Secret is required",
  googleWorkspaceDomainRequired: "Google Workspace Domain required",
  clientIdRequired: "Client ID required",
  displayNameRequired: "Display name required",
  configureGoogleWorkspaceIdentityProvider:
    "Configure Google Workspace Identity Provider",
  configureGoogleWorkspaceIdentityProviderDesc:
    "Enable secure Single Sign-On (SSO) with Google Workspace. Let your users log in to the MDM portal using their Google credentials via OpenID Connect (OIDC).",
  microsoftIdentityProviderTitle:
    "Welcome to Microsoft Entra ID Identity Provider ",
  microsoftIdentityProviderDescription: `Allow your users to log in using Microsoft Entra ID (formerly Azure AD). This integration supports secure SSO via OpenID Connect (OIDC).`,
  singleSignOnSso: "Single Sign-On (SSO)",
  microsoftSingleSignOnSsoDescription:
    "Authenticate users with Entra ID using secure OIDC standards.",
  multiTenantSupport: "Multi-tenant Support",
  microsoftIdentityMultiTenantSupportDesc:
    "Set up connections for different teams or business units.",
  tokenBasedSecurity: "Token-based Security",
  googleIdentityProviderTokenBasedSecurityDesc:
    "Enterprise-grade encryption and token validation via OAuth.",
  microsoftIdentityProviderRequirement1: "Reading user basic profiles",
  microsoftIdentityProviderRequirement2:
    "Validating tokens and tenant information",
  microsoftIdentityProviderRequirement3: "Authenticating via OpenID Connect",
  tenantDomain: "Tenant Domain",
  microsoftIdentityTenantDomainDesc:
    "The domain of your Microsoft Entra ID tenant.",
  microsoftIdentityClientIdDesc:
    "The unique identifier for your registered Microsoft Entra ID application.",
  microsoftIdentityNameFieldDesc:
    "The Client secret for the Microsoft Entra ID application.",
  microsoftWorkspaceDomainRequired: "Microsoft Domain required",
  microsoftClientSecretIsRequired: "Client Secret is required",
  identityProvider: "Indentity Provider",
  identityProviderBreadcrumpDesc:
    "dentity providers enable Single Sign-On (SSO) so users can access Trio using their existing organizational credentials from Google Workspace or Microsoft Entra ID, eliminating the need for separate Trio passwords.",
  disconnectIdentityProvider: "Disconnect Identity Provider",
  disconnectIdentityProviderDesc: `Users will no longer be able to sign in via {{name}} and
              must be login with password or fallback methods.`,
  deleteIdentityProvider: "Delete Identity Provider",
  deleteIdentityProviderDesc: `This will permanently delete the configuration for {{name}}.
All users who log in through this provider will immediately lose access unless you’ve enabled fallback login.`,
  thisActionCannotBeUndone: "This action cannot be undone.",
  continueWith: "Continue with",
  communication: "Communication",
  monitoring: "Monitoring",
  backupDes:
    "Protect your organization’s data with endpoint backup and recovery integrations.",
  commucationDes:
    "Send alerts and updates directly to your team through collaboration tools.",
  addEvent: "Add event notification",
  monitoringDes:
    "Connect with analytics and SIEM platforms to track device activity, security events, and operational metrics.",
  securityApps: "Security Apps",
  securityDes:
    "Enhance protection with integrations for network access control, data loss prevention, and compliance automation.",
  Manual: "Manual",
  NA: "N/A",
  GSUITE: "G-Suite",
  MICROSOFT_ENTRA_ID: "Microsoft Entra ID",
  recommendForSilentEnrollment: "Recommend for silent enrollment",
  openPowershell: "Open PowerShell",
  openPowershellUsingRunAsAdministrator:
    "Open PowerShell using (Run As Administrator).",
  runCommand: "Run command",
  runCommandPowershellDescription:
    "Copy and paste the following command into PowerShell.",
  editTags: "Edit tags",
  addTags: "Add tags",
  removeTags: "Remove tags",
  manageTags: "Manage tags",
  searchTags: "Search Tags",
  createTag: "Create tag",
  tagName: "Tag name",
  createTagDescription: `Set a clear name for e.g., Finance, Loaner, VIP`,
  statusOptions: "Status Options",
  blockAll: "Block all",
  whitelist: "Whitelist",
  noRemovableStoragesAddedYet: "No removable storages added yet",
  whitelistedStorages: "Whitelisted Storages",
  openTerminal: "Open Terminal",
  openTerminalDescription: "Open Terminal in your macOS.",
  runCommandInTerminal: `Copy and paste the command into Terminal.
`,
  assignToDeviceGroup: "Assign to device groups",
  deviceGroup: "Device Group",
};
